
export const matchingModeOptions = [
    {
        label: '精确',
        value: 'exact',
    },
    {
        label: '前缀',
        value: 'prefix',
    },
    {
        label: '正则',
        value: 'regex',
    },
];
